export default __webpack_public_path__ + "static/media/contract.96228291.svg";